import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { Card as CardComponent, PromotionalBanner } from '@savebetter/components';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionDescription } from './PageSectionDescription';
import { PageSectionHeader } from './PageSectionHeader';
import { Section } from './Section';

interface Card extends SbBlokData {
  link: LinkProps[];
  media: MediaProps[];
  title: string;
  paragraph: string;
}

interface Blok extends PageSectionBlok {
  title: string;
  description?: string;
  cards: Card[];
}

interface CardList1Props extends PageSectionProps {
  blok: Blok;
}

export const CardList1: FunctionComponent<React.PropsWithChildren<CardList1Props>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, description, cards = [], hasPaddingBottom, hasPaddingTop } = blok;

  return (
    <Section
      width="sm"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader>{title}</PageSectionHeader>
      {description && <PageSectionDescription>{description}</PageSectionDescription>}
      {cards.map(card => (
        <CardComponent className="pb-small mb-8 last:mb-0" {...storyblokEditable(blok)} key={card._uid}>
          <PromotionalBanner
            mediaProps={{ src: card.media[0].img, alt: card.media[0].alt, loading: 'lazy' }}
            heading={card.title}
            headingColor="text-primary"
            text={card.paragraph}
            addAccordion={true}
            linkTarget={card.link[0].target}
            linkLabel={card.link[0].text}
            linkUrl={card.link[0].url}
          />
        </CardComponent>
      ))}
    </Section>
  );
};
